// overridden to have ability to take the given id and not to generate a new one

import {
  serializeNodes,
  serializeNodesToText,
} from '@plone/volto-slate/editor/render';
import config from '@plone/volto/registry';
import isEqual from 'lodash/isEqual';
import Slugger from 'github-slugger';
import { normalizeString } from '@plone/volto/helpers/Utils/Utils';

const TextBlockView = (props) => {
  const { id, data, styling = {} } = props;
  const { value, override_toc } = data;
  const metadata = props.metadata || props.properties;
  const { topLevelTargetElements } = config.settings.slate;

  const getAttributes = (node, path) => {
    // Get attributes from value and normalize class to className
    const attrs = value?.[0]?.attributes || {};
    const normalizedAttrs = { ...attrs };
    if (normalizedAttrs.class) {
      normalizedAttrs.className = normalizedAttrs.class;
      delete normalizedAttrs.class;
    }
    const res = { ...styling, ...normalizedAttrs };
    if (node.type && isEqual(path, [0])) {
      if (
        (!res.id && topLevelTargetElements.includes(node.type)) ||
        override_toc
      ) {
        const text = serializeNodesToText(node?.children || []);
        const slug = Slugger.slug(normalizeString(text));
        res.id = slug || id;
      }
    }
    return res;
  };

  return serializeNodes(value, getAttributes, { metadata: metadata });
};

export default TextBlockView;
